import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import PropTypes from 'prop-types'
import React from 'react'
import View from '../../view'
import F11 from '../f11'
import OutOfBand from '../out-of-band'
import Banner from '../banner'
import Slide from '../slide'
import Header from '../header'
import State from '../../state'
import Toaster, { Toast } from '../toast'
import '../slide/index.css'
import './index.css'
import { q } from '../../state/part/free-q'
import { Ref, STAGE, stage, getConfig, promise, eId, goOffline, Test, Route, Param, cache, copy, cookies, equal, session } from '../../../global'
import { connect } from 'react-redux'
import { masterStateToProp, masterDispatchToProp } from '../../../type'
import { cartMerge, dispatch, tcp, go, tact } from '../../../io/'
export const ID = 'viewmaster'
// let _id_ = 0
Ref[ID] = {}
const _Master_ = Ref[ID]
const Row = Ref.row
const Field = Ref.field
const __DEV__ = import.meta.env.__DEV__
export class MasterView extends View {
  static ID = ID
  static V = [ F11, Header, Slide, Banner, OutOfBand, State ]
  constructor (p, c) {
    super(p, c)
    this.state = MasterView.init(p)
    this.singletonRef = null
    this.singletonUrl = null
    // this.state.key = `${ ID } ${ _id_++ }`
    // this.state._id_ = _id_
  }
  static initial = (p, s, cookie) => {
    // const park = p.p
    // const connected = p.io.connected
    const connected = Ref.socket.connected
    const login = cookie.login// || false
    const username = cookie.username
    const uid = cookie.id
    const master = p.init.master?.response
    const _route = Route()
    const visit = cache('visit')
    // setTimeout(()=>{
      // if (window.location.pathname.includes('media')) debugger
    // },3333)
    const _param = Param()
    const param = Object.keys(_param).reduce((acc, p)=>{
      acc.push(`${p}=${_param[p]}`)
      return acc
    }, [])
    // if (window.opener && window.location.search) debugger
    const query = param.length ? `?${param.join('&')}` : ''
    // let lang=_.EN, u='page', uri, vendorname='master', pk, more=query || '?expand=1&maps=1'//, uris=[]
    // let lang=_.EN, u=_.SCREEN_[0], uri, vendorname='master', pk, more=query
    let lang=param.lang || _.EN, u=_.SCREEN_[0], uri, vendorname='master', pk//, more=query
    // let lang=_.EN, u='ride', uri, vendorname='master', pk, more//, uris=[]
    // if (_uris.length) {
    //   if (_.LANG_.includes(_uris[0])) {
    //     lang = _uris[0]
    //     _uris.shift()
    //   }
    // }
    // if (param.lang) debugger
    if (_route.length) {
      vendorname = _route[0]
      // if (vendorname!='master') u='store'
      if (!_.TITLE_.includes(vendorname)) u='store'
      _route.shift()
    }
    if (_route.length) {
      u = _route[0]
      _route.shift()
    }
    if (_route.length) {
      // if (!isNaN(_route[0])) {
        pk = _route[0]
      // } else more = _uris
      // pk = _uris[0]
      _route.shift()
    }
    // if (_uris.length) {debugger;more = _uris}
    const owner = login && username==vendorname
    // const owner = login && uid==vid
    // let uris = [lang, vendorname]
    let route = [vendorname]
    // if (vendorname=='master') {
    if (_.TITLE_.includes(vendorname)) {
      switch (u) {
        // case 'pay':break
        // if (window.opener) break
        case 'online':
        if (connected) break
        // else if (visit && visit.length) uris = visit
        else if (visit?.length) route = visit
        else if (s.visit.length) {debugger
          u='store'
          vendorname = s.visit[0]
          // uris = [lang, vendorname]
          route = [vendorname]
        // } else if (p.history.length > 2) {
        } else if (p.history.length > 2) {debugger
          u='store'
          p.history.goBack()
        } else {u='welcome';debugger}
        break
        // case _.SCREEN_.includes(u):
        // case 'forgive':
        case 'otp': route.push(u)
        // if (!(s.visit.length>2 && s.visit[2]=='login')) {debugger; u='login'}
        case 'ride':
        case 'parcel':
        case 'search':
        case 'stage':
        case 'driver':
        case 'deliver':
        case 'sponsor':
        break
        default:
        if (_.MASTER_.includes(u)) break
        // if (_.USER_.includes(u)) break
        // u='page'
        // u='ride'
        u='welcome'
      }
    } else {
      switch (u) {
        // case 'ride':
        case 'paid':
        case 'pay':break
        case 'online':
        if (connected) break
        // else if (s.visit.length) {
        else {
          u='store'
          break
        }
        case 'edit': if (owner) break
        // case 'stage':
        // if (!owner) {
        //   uris.push(u)
        //   break
        // }

        default:
        if (_.PRIVATE_.includes(u) && owner) break
        if (_.Q_.includes(u) && !_.PRIVATE_.includes(u)) break
        u='store'
      }
    }
    // uris = [lang, vendorname]
    if (u=='online' && !connected || (u=='ride' || u=='pay' || u=='paid') && window.opener) {/* nothing */if (u!='online') debugger}
    else if (_.PART_.includes(u)) route.push(u)
    // if (_.PART_.includes(u)) uris.push(u)
    // if (pk && uris.length>2) uris.push(pk)
    if (pk && route.length>1) route.push(pk)
    // if (more && uris.length>2) uris = [...uris, ...more]
    // if (more && uris.length>2 && IO.select) uris = [...uris, ...more]
    // if (more && uris.length>2) uris = [...uris, more]
// if (window.location.pathname.includes('media')) debugger
    // if ((query || u=='page') && uris.length>2) uris = [...uris, more]
    // if (vendorname=='master') {
    if (_.TITLE_.includes(vendorname)) {
      // const test = (u=='welcome' || u=='ride' || u=='parcel' || u=='search' || u=='stage' || u=='driver' || u=='deliver' || u=='sponsor' || u=='pay' || u=='paid') ? false : master[u].test
// if (u=='otp')debugger
      const test = (_.LOCAL_.includes(u)) ? false : master[u].test
      const status = test ? Test({test}, login ? 1 : 0) : true
      // if (u=='otp')debugger
      // if (status) {
      //   if (u=='otp' && login) {
      //     if (s.visit.length && s.visit[1] !== vendorname) {
      //       uris = s.visit
      //       u = uris.length > 2 ? uris[2] : 'store'
      //       vendorname = uris[1]
      //     } else if (login) {
      //       u = 'profile'
      //       uris = [lang, vendorname, u]
      //     }
      //   }
      // } else {
      // if (!status || u=='otp') {
      if (!status) {
        // if (s.login==login) {
        //   u = 'error'
        //   uris = [lang, 'master', u]
        // } else
        // if (u=='otp') {}
        // else
        if (s.visit.length && s.visit[0]!==vendorname) {
          route = s.visit
          // u = uris.length > 2 ? uris[2] : 'store'
          u = route.length > 1 ? route[1] : 'store'
          // vendorname = uris[1]
          vendorname = route[0]
        } else if (login) {
          u = 'profile'
          // uris = [lang, 'master', u]
          // uris = [lang, vendorname, u]
          route = [vendorname, u]
        }
        else {
          // u = 'page'
          // if (u!='otp')
          u = 'ride'
          // uris = [lang, 'master', u]
          route = ['master', u]
        }
        // param = [`ref=${u}`]
        // u = 'error'
        // uris = [lang, 'master', u]
      }
      // else if (u=='otp' && login) {
      //   if (s.visit.length && s.visit[1] !== vendorname) {
      //     uris = s.visit
      //     u = uris.length > 2 ? uris[2] : 'store'
      //     vendorname = uris[1]
      //   } else if (login) {
      //     u = 'profile'
      //     uris = [lang, vendorname, u]
      //   }
      // }
    }
    console.log('initial', window.opener, {lang, u, route, param, s})
    // document.title = (u=='ride' || u=='pay' || u=='paid') ? `master ${u}` : (_.MASTER_.includes(u) ? `AppsWhat ${u}` : (u=='store' ? `${vendorname} ${master.store.i}` : `${vendorname} ${master[u].i} ${uris.length>3 && !isNaN(uris[3]) ? uris[3]:''}`))
    // document.title = (_.LOCAL_.includes(u)) ? `master ${u}` : (_.MASTER_.includes(u) ? `AppsWhat ${u}` : (u=='store' ? `${vendorname} ${master.store.i}` : `${vendorname} ${master[u].i} ${uris.length>3 && !isNaN(uris[3]) ? uris[3]:''}`))
    // if (!master) debugger
    document.title = (_.LOCAL_.includes(u)) ? `master ${u}` : (_.MASTER_.includes(u) ? `AppsWhat ${u}` : (u=='store' ? `${vendorname} ${master.store.i}` : `${vendorname} ${master[u].i} ${route.length>2 && !isNaN(route[2]) ? route[2]:''}`))
    // if (!(s.u==u && s.uris[1]==uris[1])) p.action.u(uris)
    // if (window.location.pathname + window.location.search != `/${uris.join('/')}${query}`) return go(p.history.replace, uris, param)
    if (!(s.u==u && s.route[0]==route[0])) p.action.u(route, _param)
// if (u=='store' && connected) debugger
    // cache('visit', uris)
    // const goingOnline = uris.length>2 && uris[2]=='online'
    const goingOnline = route.length>1 && route[1]=='online'
    // if (!connected && !goingOnline) {cache('visit', uris);debugger}
    // if (!connected && !goingOnline) cache('visit', s.visit || uris)
    if (!connected && !goingOnline) cache('visit', route)
if (typeof u != 'string') debugger
    return {u, route, lang, param, query, vendorname, pk}
  }
  componentDidMount = () => {
    // _Master_[this.state.key] = this
    // IO[ID].message = this.message
    // _Master_._id_ = this.state._id_
    _Master_.message = this.message
    // IO[ID].setMaster = this.setMaster
    _Master_.setMaster = this.setMaster
    // IO[ID].setWakeup = this.setWakeup
    // IO[ID].login = this.login
    _Master_.login = this.login
    // if (__DEV__) IO[ID].onRegister = this.onRegister
    console.log({ID, 'componentDidMount state': this.state})
    window.addEventListener("resize", this.resize, false)
    this.unlisten = this.props.history.listen((location, action) => {
      const cookie = cookies()
      const state = this.state
      const v = state.views[0]
      const prop = this.props
      const {master, uid, vid} = state
      const park = prop.park
      // const connected = prop.socket.connected
      const connected = Ref.socket.connected
      const url = `/${state.route.join('/')}${state.query}`
      if (location.pathname + location.search == url) {
        console.log('unlisten do nothing as pathname and url are same')
        return
      }
      const {u, route, param, query} = MasterView.initial(prop, state, cookie)
      // const goingOnline = uris.length>2 && uris[2]=='online'
      const goingOnline = route.length>1 && route[1]=='online'
      console.log('go unlisten', {action, location, route})
      if (connected && !goingOnline) {
        // if (!this.state._unlisten) this.setState(_s => {
        //   console.log({_s})
        //   // debugger
        //   prop.history.go(1)
        //   _s._unlisten = 1
        //   return _s
        // })
        // prop.history.go(1)
        // const pvid = prop.p[`${_.P}${vid}`]
        // console.log('before', IO.store.getState().master, IO[`${_.P}${vid}`], {p: copy(prop.p), pvid: prop.p[`${_.P}${vid}`]})
        // console.log(`before 1 ${location.pathname}`, {p: copy(prop.p), pvid: copy(prop.p[`${_.P}${vid}`])})
        go(()=>{}, route, param, r => {
          if (r) {
            console.log('go unlisten', {action, location, r})
            // prop.history.go(-1)
            // this.setState({_unlisten: 0})
            // this.setState(_s => {
            //   _s._unlisten = 0
              // prop.history.go(-1)
            //   return _s
            // })
          } else {
            console.log('go unlisten user cancel', action, url)
            // prop.history.go(1)
            // console.log('after', copy(prop.p))
            // console.log('before', {p: copy(prop.p), pvid: prop.p[`${_.P}${vid}`]})
            // if (!pvid) debugger
            prop.history.goForward()
            // console.log('before 1', IO.store.getState().master, IO[`${_.P}${vid}`], {p: copy(prop.p), pvid: prop.p[`${_.P}${vid}`]})
            // dispatch({buffer})
            // console.log(`before 2 ${location.pathname}`, {p: copy(prop.p), pvid: copy(prop.p[`${_.P}${vid}`])})
            // this.setState({_unlisten: 0})
            // return this.setState(_s => {
            //   prop.history.goForward()
            //   return {connected}
            // })
            return
          }
        })
      }// else {
        // this.setState({toggle: !state.toggle, uris, _unlisten: 0})
        // else {debugger
        //   this.setState({toggle: !state.toggle, route})
        // }
      //}
    })
    window.addEventListener('message', this.onMessage, false)
    document.addEventListener('visibilitychange', this.onVisibilityChange)
    setTimeout(() => {
      this.lockWake()
    }, 1111)
  }
  lockWake = () => {
    // if (!navigator.wakeLock) return
    navigator.wakeLock.request('screen')
    .then(wakeLock => {
      this.setState({wakeLock})
      console.log({visible: document.visibilityState, wakeLock})
      wakeLock.addEventListener('release', () => {
        console.log({visible: document.visibilityState, wakeLock: this.state.wakeLock})
        this.setState({wakeLock: null})
      })
    })
    .catch(err => console.log({err}))
  }
  onVisibilityChange = e => {
    const noop = this.singletonRef && (this.singletonUrl.includes('cart') || this.singletonUrl.includes('map'))
    const scrollY = window.scrollY
    const scrollX = window.scrollX
    if (document.visibilityState === 'visible') {
      if (!noop) window.scroll(this.state.scrollX, this.state.scrollY)
      this.lockWake()
    } else if (!noop) this.setState({scrollX, scrollY})
  }
  // route = () => IO.map.route.reduce((acc, marker, i) => {
  //   const geoCode = JSON.parse(JSON.stringify(marker.geoCode))
  //   const init = {}
  //   if (marker.name) init.name = marker.name
  //   if (marker.order) init.order = marker.order
  //   if (marker.pick) init.pick = marker.pick
  //   if (marker.count) init.count = marker.count
  //   if (marker.vendor) init.vendor = marker.vendor
  //   if (marker.instruct) init.instruct = marker.instruct
  //   geoCode.init = init
  //   acc.push(geoCode)
  //   return acc
  // }, [])
  onMessage = e => {
    // e.preventDefault()
    // e.stopPropagation()
    if (!e.data) return
    const p = this.props
    const {/*route, */lang, vid, param, cookie} = this.state
    const park = p.park
    const _v = 'purchase'
    const data = e.data || {}
    // console.log(window.opener ? 'child recieve':'mother recieve', data)
    Object.keys(data).reduce((acc, k) => {
      if (k=='dbg') {console.log(data);return acc}
      if (data[k] == null) return acc
      const m = data.m || 0
// if (m) debugger
      const key = `${k}${m}`
      let row = data[k]
      switch (k) {

        // case 'route':
        // if (data[k] == '?') {
        //   promise(r => {
        //     console.log(r.p)
        //     if (!r.p.map) return true
        //     this.message({[k]: this.route()})
        //   })
        // } else {
        //   // row = data[k]
        //   // if (IO.map.route) IO.map.setRoute(row)
        //   // else
        //   this.setState({[k]: row}) // for children to see ... no consumer
        // }
        // break

        case 'end':
        case 'origin':
        if (data[k] == '?') {
          const cfg = park.config[vid].default
          const cfgId = Object.keys(cfg)[0]
          row = JSON.parse(cfg[cfgId].map)
          row.title = cfg[cfgId].title
          row.name = vendor.name
          row.home = vendor.home
          this.message({'origin': row}) // origin
          // this.message({'route': route || '?'})
          this.message({'cart': park[_v][vid].default[p.new[vid][_v]]})
        } else this.setState({[k]: data[k]})
        break

        case 'cart':
        // if (data[k]==null) return acc
        if (data[k] == '?') {
          // const el = eId(key)
          // this.message({cart: IO[ID][key], m: data.m})
          this.message({cart: _Master_[key], m: data.m})
          return acc
        } else if (typeof data[k] != 'object') {debugger;return acc}
        // row = data[k]
        // IO[ID][key] = row
        _Master_[key] = row
        const cart = JSON.parse(row.json)
        // const v = 'purchase'
        // if (window.opener && param.cart) {
        if (window.opener && param.cart) {
          const npk = p.new[vid][_v]
          dispatch({buffer: {[cookie.p]: {[_v]: {[vid]: {default: {[npk]: row}}}}}})
this.message({dbg: 'dispatch'})
          const buff = {}
          let r
          cart.forEach((kv, i) => {
            const [pk, stock, price, v='item'] = kv
            // const
            r = park[v]?.[vid]?.default?.[pk] || cache(`${lang}${row.vendor}${v}${pk}`)
            // if (!r) {
              if (!buff[v]) buff[v] = {}
              if (!buff[v].default) buff[v].default = 'find'
              if (!buff[v][vid]) buff[v][vid] = {}
              if (!buff[v][vid].default) buff[v][vid].default = {}
              buff[v][vid].default[pk] = 'find'
            // }
          })
          // if (Object.keys(buff).length)
          // tcp({debug: ID, buffer: buff}, this.state.vendor.home)
          // tcp({buffer: {[cookie.p]: buff}}, this.state.vendor.home)
          tcp({lang, buffer: {[this.state.vendor.home]: buff}})
this.message({dbg: 'tcp', buff, r, 'home': this.state.vendor.home})
          setTimeout(() => {
if (!this.state.slide) debugger
            this.state.slide('t', 'show')
          }, 2222)
          return acc
        }
        // const route = IO.route && IO.route[m] || {}
        const route = Ref.route?.[m] || {}
        console.log({route}, IO)
        if (route.cart && route.item) {
          route.cart.innerHTML = `cart ${cart.length} item`
          if (route.item.hasChildNodes())
            while (route.item.firstChild)
              route.item.removeChild(route.item.firstChild)
          cart.forEach((kv, i) => {
            const [pk, stock, price, v] = kv
            const r = cache(`${lang}${row.vendor}${v}${pk}`)

            const item = document.createElement('div')
            item.style.display = 'flex'
            item.style.margin = '5px'
            item.style.border = '1px dotted'

            const sStock = document.createElement('span')
            sStock.style.margin = '5px'
            sStock.innerHTML = stock

            const sTitle = document.createElement('span')
            sTitle.style.margin = '5px'
            sTitle.innerHTML = r.title.substring(0, 40)

            const sPrice = document.createElement('span')
            sPrice.style.margin = '5px'
            sPrice.innerHTML = price

            item.append(sStock)
            item.append(sTitle)
            item.append(sPrice)

            route.item.append(item)
          })
          let item = document.createElement('div')
          item.style.display = 'flex'
          item.style.margin = '5px'
          // item.style.border = '1px dotted'

          const lTip = document.createElement('label')
          lTip.innerHTML = 'Tip'
          const iTip = document.createElement('div')
          iTip.style.margin = '5px'
          iTip.innerHTML = row.tip
          item.append(lTip)
          item.append(iTip)

          const lTax = document.createElement('label')
          lTax.innerHTML = 'Tax'
          const iTax = document.createElement('div')
          iTax.style.margin = '5px'
          iTax.innerHTML = row.tax
          item.append(lTax)
          item.append(iTax)

          const lTotal = document.createElement('label')
          lTotal.innerHTML = 'Total'
          const iTotal = document.createElement('div')
          iTotal.style.margin = '5px'
          iTotal.innerHTML = row.total
          item.append(lTotal)
          item.append(iTotal)

          route.item.append(item)
          console.log(row)
        }
        // break
        // case 'm':
        // break
        // default:
        // debugger
      }
      return acc
    }, {})
    if (Object.keys(data).length) return
    const {db, v, pk, verb, id, selected, extra=''} = data
    this.setState({select: selected}, () => console.log({db, v, pk, selected}, this.state.select))
    console.log(data)
    // const field = Fields[db][v][pk][verb][id][extra]
    const field = Field[ `${ db } ${ v } ${ verb } ${ pk } ${ id }${ extra }` ] //[db][v][pk][verb][id][extra]
if (field) debugger
if (!field) debugger
    const state = JSON.parse(park[v][db].default[pk][id])
    // const maps = id=='map'
    // const stale = !equal(JSON.parse(park[v][db].default[pk][id]), selected)
    const stale = id=='map' ? !equal(state.media || [], selected) : !equal(state, selected)
    // const value = selected
    // const cfgMp =
    setTimeout(() => {
      field.init({ value: selected, stale })
      // field.init(maps ? {cfgMap, stale} : {value, stale})
      // field.init(maps ? {cfgMap, stale} : {value, stale})
      // const row = IO.row[db][v][pk]
      const row = Row[ `${ db } ${ v } ${ verb } ${ pk }`]
  debugger
      row.onFieldChange(id, {
        stale,
        preview: row.preview,
        value: selected,
      })
      console.log({stale, selected, field, row, Ref})
    }, 111) // wait for visibleChange scroll row on screen otherwise React complaining no-op memory-leak
    // if (data.ID == 'state') {
    //   switch (data.cmd) {
    //     // case 'close': alert('Child window closed')
    //   }
    // }
  }
  // toggle = () => this.setState({toggle: !this.state.toggle})
  message = m => {
    console.log(window.opener ? 'child':'mother', m)
    // if (m) this.setState(m)
    if (window.opener) {
      // window.opener.postMessage(JSON.stringify({...(this.state.param), ID, 'selected': this.state.select, 'child': 1}))
      window.opener.postMessage(m||{...(this.state.param), ID, 'selected': this.state.select, 'child': 1})
    } else if (this.singletonRef) {
      // this.singletonRef.postMessage(JSON.stringify({...(this.state.param), ID, 'selected': this.state.select, 'parent': 1}))
      this.singletonRef.postMessage(m||{...(this.state.param), ID, 'selected': this.state.select, 'parent': 1})
    } else console.log('nothing to do')
  }
  singletonTab = (e, url) => {
    e.preventDefault()
    e.stopPropagation()
    if (this.singletonRef === null || this.singletonRef.closed) {
      this.singletonRef = window.open(url, ID)
      // this.setState({singletonRef: window.open(url, ID)})
    } else if (this.singletonUrl !== url) {
      this.singletonRef = window.open(url, ID)
      // this.setState({singletonRef: window.open(url, ID)}, this.state.singletonRef.focus())
      // if (!this.singletonRef) debugger
      // this.singletonRef.focus()
    } else this.singletonRef.focus()
    // this.setState({singletonUrl: url})
    this.singletonUrl = url
  }
  setSelect = (pk, selected) => {
    const {select, param} = this.state
    // if (!select) debugger
    // debugger
    // const _select = select ? [...select] : []
    const _select = param.select>1 ? [...select] : []
    if (param.select==1) {
      // console.log({...param}, IO.row)//[param.db][param.v][param.pk])
      // debugger
      select.forEach(pk => {
        // IO.row[param.db].media[pk].setRow({select: false})
        Row[param.db].media[pk].setRow({select: false})
      })
    }
    if (_select.includes(pk)) {
      if (!selected) {
        _select.splice(_select.indexOf(pk), 1)
        this.setState({select: _select}, () => console.log(this.state.select))
      }
    } else if (selected) {
      this.setState({select: [..._select, pk]}, () => console.log(this.state.select))
    }
  }
  static init = p => {
    const cookie = cookies()
    // return {/*selected: false, select: false, */connected: false, views: [], wakeup: {}, uris: [], param: {}, cookie, login: cookie.login, visit: [], query: '', init: false, toggle:false, cartCount: {}, singletonUrl: ID, singletonRef: null, wakeLock: navigator.wakeLock.request('screen')}
    return {/*selected: false, select: false, */connected: false, views: [], wakeup: {}, route: [], param: {}, cookie, login: cookie.login, visit: [], query: '', init: false, toggle:false, cartCount: {}, /*singletonUrl: ID, singletonRef: null,*/
    // wakeLock: s.wakeLock?.released ? navigator.wakeLock.request('screen') : s.wakeLock}
      // wakeLock: navigator.wakeLock.released ? navigator.wakeLock.request('screen') : navigator.wakeLock
    }
  }
  static getDerivedStateFromProps(props, state) {
    // const { socket, ...p } = props
    const p = props
    // const connected = Ref.socket.connected// p.io.connected
    const init = MasterView.init(p)
    const master = p.init?.master?.response
if (props.find?.what) debugger
    if (!master) {
      console.log({[ID]: 'getDerivedStateFromProps !master', master, route: init.route, props, p})
      p.action.init(ID)
      return init
    }
    const cookie = cookies()
    const login = cookie.login
    const uid = Number(cookie.id)
    const { u, route, param, lang, query, pk } = MasterView.initial(props, state, cookie)
    const { park } = p
    if (!park) {
      console.log({[ID]: 'getDerivedStateFromProps !park', park, q})
      dispatch({buffer: {[cookie.p]: {q: {[uid]: {default: {[0]: q}}}}}})
      return {...init, u, route, param, query}
    }
    const e = park?.[u]?.e
    const vendor = p.p.vendor || {}
    if ((u=='store' || _.Q_.includes(u)) && !(vendor.username==route[0])) {
      console.log({[ID]: 'getDerivedStateFromProps (u==store || _.Q_[u]) && !(vendor.username==route[1])', u, vendor, route})
      return {...init, u, route, param, query}
    }
    // if (login && !(park.login?.user?.default?.[cookie.id])) {
    if (!park.login?.user?.default?.[uid]) {
      console.log({[ID]: 'getDerivedStateFromProps login && !(park.login && park.login.user && park.login.user.default && park.login.user.default[cookie.id])', login, park})
      if (login) {
        dispatch({buffer: {[cookie.p]: {login: {user: {default: {[uid]: session(`${uid}[]`)}}}}}})
        console.log('CHECK here the login session expiring, if less than a day the tcp to renew')
      }
      else {
        dispatch({buffer: {[cookie.p]: {login: {user: {default: {[uid]: [uid]}}}}}})
        sessionStorage.clear()
      }
    }
    const vid = Number(vendor.id)
    const owner = login && uid==vid
    const emptyStore = u=='store' && _.STORE_.every(v => park[v]?.[vid]?.[_.PUB]==0)
    const npk = p.new[vid]?.purchase
    const nrow = owner ? null : park.purchase?.[vid]?.default?.[npk]
    const cartCount = !vid ? {} : {
      ...state.cartCount,
      [vid]: !nrow ? 0 : JSON.parse(nrow.json).reduce((acc, [pk, stock]) => (acc+stock), 0)
    }
    if (login != state.login) {
      const purchase = nrow && copy(nrow)
      const buff = { buffer: { [cookie.p]: { q: { [uid]: { default: { [0]: q } } } } } }
      if (purchase) {
        purchase.customer = uid
        buff.buffer[cookie.p].purchase = { [vid]: { default: { [npk]: purchase } } }
      }
      dispatch(buff)
    }
    if (window.location.href.includes('origin=?')) param.origin='?'
    // if (window.location.href.includes('cart=?')) param.cart='?'
    const opc = typeof param.origin != 'undefined'
    const cpc = typeof param.cart != 'undefined'
    // const spc = typeof param.select != 'undefined'
    // if (spc) debugger
    const lpc = opc || cpc
    // if (state.connected != Ref.socket.connected) {debugger;action.connect(Ref.socket.connected)}
    const _state = {
      ...init,
      ...state,
      // wakeLock: state.wakeLock || navigator.wakeLock.request('screen'),
      opc, cpc, lpc,
      select: state.select || JSON.parse(param.selected || '[]'),
      init: true,
      cartCount: cartCount,//Object.keys(state.cartCount).length ? state.cartCount : {[vid]: ''},
      visit: (u=='store' || _.Q_.includes(u)) ? route : state.visit,
      // visit: uris,
      username: cookie.username,
      vendorname: vendor.username,
      pk,
      uid,
      vid,
      // pvid: park[`p${vid}`],
      npk,
      // isVendor: uid==vid,
      emptyStore,
      vendor,
      cookie,
      lang,
      connected: Ref.socket.connected,
      route,
      param,
      paramCart: typeof param.cart != 'undefined',
      query,
      master,
      u,
      views: u=='store' ? _.STORE_ : (_.USER_.includes(u) ? ['login'] : [u]),
      login,
      owner,
      e,
      wakeup: state.wakeup,
      verb: _.LOGIN_[u] || _.LOGOUT_[u] || 'default',
      albumI: master.album.i.l,
      openI: master.open.i.l,
      closeI: master.close.i.l,
      okI: master.ok.i,
      cancelI: master.cancel.i,
      // successI: master.success.i,
      placeI: master.place.i,
      pinI: master.pin.i,
      nameI: master.name.i,
      typeI: master.type.i.l,
      phoneI: master.phone.i.l,
      emailI: master.email.i.l,
      webI: master.web.i,
      frontI: master.front.i,
      paidI: master.paid.i,
      cartI: master.cart.i,
      updateI: master.update.i,
      deleteI: master.delete.i,
      autoI: master.auto.i,
      sendI: master.send.i,
      unknownI: master.widgetlogin.i,
      customerI: master.customer.i,
      lockI: master.lock.i,
      purchaseI: master.purchase.i,
      orderI: master.order.i,
      employeeI: master.employee.i,
      vendorI: master.vendor.i,
      shipperI: master.shipper.i,
      youI: master.u.i,
      storeI: master.store.i,
      stageI: master.stage.i,
      editI: master.edit.i,
      chatI: master.chat.i,
      newI: master.new.i,
      rideI: master.ride.i,
      deliverI: master.deliver.i,
      cartSound: `https://${cookie.p}.${_.DOMAIN}/usr/pub/img/cart.mp3`,
      userSound: `https://${cookie.p}.${_.DOMAIN}/usr/pub/img/user.mp3`,
      chatSound: `https://${cookie.p}.${_.DOMAIN}/usr/pub/img/chat.mp3`,
      favicon: {alt: 'favicon', src: `https://${cookie.p}.${_.DOMAIN}/usr/pub/img/favicon.jpg`},
      new: {alt: 'new', src: `https://${cookie.p}.${_.DOMAIN}/usr/pub/img/new.jpg`},
      media: {alt: 'media', src: `https://${cookie.p}.${_.DOMAIN}/usr/pub/img/media.jpg`},
      uarr: <>&uarr;</>,
      darr: <>&darr;</>,
      larr: <>&larr;</>,
      rarr: <>&rarr;</>,
      trash: <>&#xe020;</>,
      // must: text => (<span style={{color: 'red'}}>{text}</span>),
      required: <span style = { { color: 'red' } }>*</span>,
    }
    // IO.visit = _state.visit
    _Master_.visit = _state.visit
    console.log({[ID]: 'getDerivedStateFromProps state', ..._state}, window.opener, Ref)
    // const _uris = Uris()
// if (_uris[2]=='media') debugger
    // const windowUrl = `/${Uris().join('/')}${query}`
    const windowUrl = `${window.location.pathname}${window.location.search}`
    const stateUrl = `/${_state.route.join('/')}${_state.query}`
    // if (!state.init && windowUrl!=stateUrl) setTimeout(() => go(p.history.replace, uris), 1111)
    if (windowUrl!=stateUrl) setTimeout(() => go(p.history.replace, route, param), 1)
    // IO[ID].state = _state
    _Master_.state = _state
    return _state
  }
  setMaster = state => {
    this.setState(state)
  }
  clearCache = (e, v, db, shard) => {
    console.log({[ID]: this.clearCache.name})
    const {lang} = this.state
    // const net = {debug: ID, type: 'reset', v, db, lang}
    const net = {type: 'reset', v, db, lang}
    tcp(net, shard)
    cache(`${lang}${db}${v}`, null)
    // const el = e.target
    // const text = el.innerText
    // el.innerText = master.clear.i
    // el.disabled = true
    // setTimeout(()=> {
    //   el.disabled = false
    //   el.innerText=text
    // }, 60000)
    // props.setMaster({park: copy(park)})
    // props.mount(IO.store)
    window.location.reload(true)
  }
//   setWakeup = _wakeup => {
//     // const {meta: cur, wakeup: w} = copy(_wakeup)
//     const {meta: cur, wakeup: w} = _wakeup
//     // const wakeup = copy(this.state.wakeup)
//     const wakeup = { ...this.state.wakeup }
//     let parent = cur
//     while (parent) {
//       const {db, v, pk} = parent
//       console.log({[ID]: 'setWakeup', parent, w})
//       if (!wakeup[v])     wakeup[v]={}
//       if (!wakeup[v][db]) wakeup[v][db]={}
//       // w.callback = callback
//       wakeup[v][db][pk]=w
//       parent = parent.meta
//     }
// if (!_wakeup)debugger
//     this.setState({wakeup: {...wakeup, [cur.v]: {[cur.db]: {[cur.pk]: w}}}})
//         console.log({[ID]: 'setWakeup',
//         _wakeup,
//         '{wakeup: {...wakeup, [cur.v]: {[cur.db]: {[cur.pk]: w}}}}':
//         {wakeup: {...wakeup, [cur.v]: {[cur.db]: {[cur.pk]: w}}}}
//       })
//   }
  setPurchase = ({db, pk, total: _total=0, discount: _discount=0, tip: _tip=0, purchase: purchaseNew, valid=true}) => {
    const p = this.props
    const s = this.state
    const {vid, lang, cookie, connected} = s
    const park = p.park
    const cfg = getConfig(park, lang, vid)
    const tax = Number(cfg.tax)
    const prevPurchase = copy(park.purchase[db].default[pk])
    const row = purchaseNew || prevPurchase
    // if (purchaseNew?.json.length) debugger
    console.log({purchaseNew, prevPurchase, row, db, pk})
    row.modified = Math.round(Date.now()/1000)
    const total = Number(_total || row.total || 0)
if (isNaN(_discount)) debugger
if (isNaN(_tip)) debugger
    const discount = (isNaN(_discount) || _discount==='') ? 0 : Number(_discount || row.discount || 0)
    const tip = (isNaN(_tip) || _tip==='') ? 0 : Number(_tip || row.tip || 0)
    const sub_total = Number(row.subtotal || 0)
    const taxed = Math.round(sub_total * tax)/100
    row.tip = tip > 0 ? tip.toFixed(2) : ''
    row.discount = discount > 0 ? discount.toFixed(2) : ''
    row.tax = taxed > 0 ? taxed.toFixed(2) : ''
    const __total = sub_total + taxed + tip - discount
    // row.total = __total > 0 ? __total.toFixed(2) : ''
    row.total = __total.toFixed(2)
    const buff = {buffer: {[cookie.p]: {purchase: {[db]: {default: {[pk]: row}}}}}}
    // const cartCount = {
    //   ...s.cartCount,
    //   [vid]: JSON.parse(row.json).reduce((acc, [pk, stock]) => (acc+Number(stock)), 0)
    // }
    // console.log({'tariq': 'setPurchase', buff, cartCount}, s.cartCount)
    console.log({'tariq': 'setPurchase', buff})
    // this.setState({cartCount}, console.log({'tariq': ID, cartCount}, this.state.cartCount))
    dispatch(buff)
    setTimeout(() => {
      setTimeout(() => {
        if (this.state.u=='pay' && Row[ID].pay && Row[ID].pay.toggle) Row[ID].pay.toggle()
      }, 2222)
    }, 1)
    if (connected) {
      // if (valid) {
      //   const user = p.user
      //   const u = user[db]
      //   const shard = u && u.p
      //   const isVendor = vid == uid
      //   const fid = isVendor ? vid : uid
      //   const us = u && u.stage
      //   const from = {
      //     id: uid,
      //     pk: us.pk || pk,
      //     p: cookie.p,
      //     stage: us,
      //   }
      //   const netBuff = {
      //     debug: ID,
      //     type: 'io',
      //     p: shard,
      //     io: 'purchase',
      //     to: [isVendor ? (u && u.id || db) : vid],
      //     from,
      //     data: {
      //       purchase: row,
      //     },
      //   }
      //   console.log({ID, isVendor, db, uid, vid, from, fid, netBuff, shard})
      //   // if (shard) tcp(netBuff, shard)
      // }
    } else if (row.total) {
      const uid = Object.keys(STAGE).reduce((acc, id) => {
        if (STAGE[id].id==vid) return id
        return acc
      }, false)
      console.log({STAGE, uid})
      // debugger
      // stage(uid || vid, uid ? {...STAGE[uid], purchase: row, stage: {}} : {id: uid || vid, purchase: row})
if (uid && STAGE[uid].stage?.pk) debugger
// if (uid && STAGE[uid].stage) debugger
      stage(uid || vid, uid ? {stage: {}, ...STAGE[uid], purchase: row} : {id: uid || vid, purchase: row})
      // debugger
      // if (STAGE[vid]) {
      //   debugger
      // }
      // const prev = session('purchase')
      // if (row.total) {
      //   session('purchase', {
      //     ...prev,
      //     [db]: {
      //       row,
      //       now: Date.now(),// + 1440000,
      //     }
      //   })
      // } else if (prev) {
      //   delete(prev[db])
      //   if (Object.keys(prev).length) session('purchase', prev)
      //   else session('purchase', null)
      // }
    }
    // session('purchase', {...prev, [vid]: {[Date.now() + 1440000]: row}})
  }
  // setCart = (cart, uid=this.state.vid, onChange=false, buyAgain=false) => {
  // setCart = (cart, uid=this.state.vid, onChange=false, stale=true) => {
  // setCart = (cart, uid=this.state.vid, onChange=false) => {
  // setCart = ({cart, db=this.state.vid, onChange=false, memo}) => {
  setCart = ({cart, db, onChange=false}) => {
    const p = this.props
    const s = this.state
    const { owner, lang, master, connected, vendor, cartCount, npk } = s
    const park = p.park
    // const dbs = Object.keys(p.user)
    const vid = connected ? db : this.state.vid
    console.log(ID, Ref, p.new, this.state)
    // const db = connected ? dbs[_db] : vid
    const user = connected ? { ...p.user[db] } : {}
    const pid = connected ? (user.stage?.pk || (owner ? user.id : db)) : db
    const ppk = connected ? (user.stage?.pk || (owner ? user.id : npk)) : npk
if (!park.purchase[pid]) debugger
    const purchase = copy(park.purchase[pid].default[ppk])
    const purchaseCart = cartMerge({json: purchase.json, reset: true, user})
    const mergedCart = cartMerge({json: JSON.stringify(cart), pid, onChange, user})
    purchase.json = JSON.stringify(mergedCart)
    const s0 = mergedCart.reduce((acc, [pk, stock, price]) => (acc += price*stock), 0)
    const s1 = Math.round(s0*100)/100
    purchase.subtotal = s1 ? s1.toFixed(2) : ''
    this.setPurchase({db: pid, pk: ppk, purchase})
  }
  setMaps = loader => this.maps = loader
  static c = 0
  static i = 0
  static r = 0
  render = () => {
    const {master, connected, cookie, u, slide} = this.state
    if (!master) return null
    __DEV__ && (!connected && ++MasterView.c)
    __DEV__ && (!u && ++MasterView.i)
    const { socket, ...prop } = this.props
    const p = {
      ...prop,
      master: this.state,
      setPurchase: this.setPurchase,
      setCart: this.setCart,
      setMaster: this.setMaster,
      clearCache: this.clearCache,
      maps: this.maps,
      setMaps: this.setMaps,
      singletonTab: this.singletonTab,
      singletonRef: this.singletonRef,
      singletonUrl: this.singletonUrl,
      setSelect: this.setSelect,
      message: this.message,
      onMessage: this.onMessage,
      route: this.route,
      cart: this.cart,
    }
    const minHeight = `${vw.HEIGHT}px`
    const debug = true
    return (
      <div
        id = { ID }
        dir = { this.props.dir }
        onClick = {
          e => {
            e.stopPropagation()
          // e.preventDefault()
            if (slide) slide('logo', 'hide')
          }
        }
      >
        <Toaster/>
        {/*<form action={''} method='post' encType='multipart/form-data'>*/}
        {
          MasterView.V.map(
            Component =>
              <Component
                { ...p }
                key = { Component.ID }
              />
          )
        }
        {/*</form>*/}
        <div style = { { minHeight } }>
        </div>
        { __DEV__ &&
          <div>
            <div>DEBUG</div>
            <button onClick={this.onPark} style={{height: '48px', width: '200px'}}>Park</button>
            <button onClick={this.onUnpark} style={{height: '48px', width: '200px'}}>Unpark</button>
            <button onClick={this.message} style={{height: '48px', width: '200px'}}>SingletonMessage</button>
            <button onClick={this.onClick0} style={{height: '48px', width: '200px'}}>Login.Q</button>
            <button onClick={this.onClick1} style={{height: '48px', width: '200px'}}>Login kaka</button>
            <button onClick={this.onClick2} style={{height: '48px', width: '200px'}}>Login toronto.cabab</button>
            <button onClick={this.onClick3} style={{height: '48px', width: '200px'}}>Login halal.chicken</button>
            <button onClick={this.onClick4} style={{height: '48px', width: '200px'}}>Login mona</button>
            <button onClick={this.onClick5} style={{height: '48px', width: '200px'}}>Login ab</button>
            <button onClick={this.onClick6} style={{height: '48px', width: '200px'}}>Login oj</button>
            <button onClick={this.onClick8} style={{height: '48px', width: '200px'}}>Login empty.store</button>
            <button onClick={this.onClick21} style={{height: '48px', width: '200px'}}>Login no.file</button>
            <button onClick={this.onClick22} style={{height: '48px', width: '200px'}}>Login no.item</button>
            <button onClick={this.onClick23} style={{height: '48px', width: '200px'}}>Login no.file.no.item</button>
            <button onClick={this.onClick29} style={{height: '48px', width: '200px'}}>Login decoration by asif</button>
            <button onClick={this.onClick101} style={{height: '48px', width: '200px'}}>IO</button>
            <button onClick={this.onClick102} style={{height: '48px', width: '200px'}}>Master.park</button>
            <button onClick={this.onClick103} style={{height: '48px', width: '200px'}}>Master.state</button>
            <button onClick={this.onClick104} style={{height: '48px', width: '200px'}}>Master.prop</button>
            <button onClick={this.onClick199} style={{height: '48px', width: '200px'}}>Heart.Beat</button>
            <br/>
            <p>cookie ID {cookie.id}</p>
            <b>connected {MasterView.c} </b>
            <br/>
            <b>u {MasterView.i} </b>
            <br/>
            <b>render {MasterView.r} </b>
            <br/>
            <button onClick={this.onClickHop} style={{height: '48px', width: '200px'}}>Hop</button>
            <button onClick={this.onClickr10} style={{height: '48px', width: '200px'}}>r10</button>
            <button onClick={this.onClicks10} style={{height: '48px', width: '200px'}}>s10</button>
            <button onClick={this.onClicks20} style={{height: '48px', width: '200px'}}>s20</button>
            <button onClick={this.onClickq10} style={{height: '48px', width: '200px'}}>q10</button>
          </div>
        }
      </div>
    )
  }
  onPark = () => {
    dispatch({buffer: {s10: {purchase: {[`stage-111`]: {default: {[-111]: {}, ['-112']: {}}}, [-113]: {default: {[-114]: {}, ['-115']: {}}}, ['-116']: {default: {[-117]: {}, ['-118']: {}}}}}}})
    // dispatch({buffer: {purchase: {stage: {default: {[-111]: {}}}}}})
  }
  onUnpark = () => {
    dispatch({buffer: {s10: {purchase: {[`stage-111`]: {delete: {[-111]: {}, ['-112']: {}}}, [-113]: {delete: {[-114]: {}, ['-115']: {}}}, ['-116']: {delete: {[-117]: {}, ['-118']: {}}}}}}})
    // dispatch({buffer: {purchase: {[`stage-111`]: {delete: {[-111]: {}, ['-112']: {}}}}}})
    // dispatch({buffer: {purchase: {stage: {delete: {[-111]: {}}}}}})
  }
  onClickHop = () => {
    // const buff = {
    //   // vendor: 'kaka',
    //   // lang: 'en',
    //   // buffer: {
    //     menu: 1,
    //     item: 2,
    //   // },
    // }
    // fetch ('https://10.paksof.com/fec/test.php?api=find&vendor=kaka&lang=en', {
    //   method: 'post',
    //   body: JSON.stringify(buff)
    // })
    // .then (response => response.json())
    // .then (resp => {console.log(resp);debugger})
    // return
    const xhr = new XMLHttpRequest()
    xhr.withCredentials = true;
    // const fd = new FormData()
    xhr.onabort = e => {debugger}
    xhr.onerror = e => {debugger}
    xhr.onreadystatechange = e => {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        if (xhr.response.length > 0) {
          let payload
          try {
            payload = JSON.parse(xhr.response)
            console.log(`IO try xhr.response.length ${xhr.response.length}`, payload)
          }
          catch (e) {
            payload = xhr.response
            console.log(`IO catch preview`, payload)
          }
        } else console.log(`IO xhr.response.length ${xhr.response.length}`)
      }
    }
    xhr.open('post', `https://20.paksof.com/fec/test.php?api=store`)
    // if (credential) debugger
    xhr.setRequestHeader("Content-Type", "application/json");
    // xhr.withCredentials = 1;
    xhr.send(JSON.stringify({buffer: {hello: 'world'}}))
  }
  onClickr10 = () => {
    // tcp({debug: ID, buffer: {hello: 'world'}}, 's10', 0, `https://20.paksof.com/fec/test.php?api=find`, r=>{
    tcp({buffer: {s10: {hello: 'world'}}}, 's10', 0, `https://s10.paksof.com/fec/test.php?api=find`, r=>{
      console.log(r)
    })
// return
    fetch ('https://s10.paksof.com/fec/test.php?api=store&vendor=kaka&lang=en', {
      method: 'post',
      body: JSON.stringify({vendor: 'find'}),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
    .then (r => r.json())
    .then (r => console.log(r))
    fetch ('https://s20.paksof.com/fec/test.php?api=store&vendor=kaka&lang=en', {
      method: 'post',
      body: JSON.stringify({vendor: 'find'}),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
    .then (r => r.json())
    .then (r => console.log(r))
  }
  onClicks10 = () => {
      // tcp({debug: ID, type: 'table', buffer: {hello: 'world', jello: 'lu'}}, 's10', 1, `https://20.paksof.com/fec/test.php?api=store`, r => {
      tcp({type: 'table', buffer: {hello: 'world', jello: 'lu'}}, 's10', 1, `https://20.paksof.com/fec/test.php?api=store`, r => {
        console.log(r)
      })
      // tcp({debug: ID, type: 'table', buffer: {hello: 'world', jello: 'lu'}}, 's20', 1, `https://30.paksof.com/fec/test.php?api=store`, r => {
      tcp({type: 'table', buffer: {hello: 'world', jello: 'lu'}}, 's20', 1, `https://s20.paksof.com/fec/test.php?api=store`, r => {
        console.log(r)
      })

    // fetch ('https://20.paksof.com/fec/test.php?api=store&vendor=kaka&lang=en', {
    //   method: 'post',
    //   body: JSON.stringify({vendor: 'find'})
    // })
    // .then (response => response.json())
    // .then (resp => {console.log(resp);debugger})
  }
  onClicks20 = () => {
    // tcp({debug: ID, buffer: {hello: 'world'}}, 's10', 0, `https://20.paksof.com/fec/test.php?api=store`, resp=>{
    tcp({buffer: {hello: 'world'}}, 's10', 0, `https://20.paksof.com/fec/test.php?api=store`, resp=>{
      console.log(resp)
    })
    // tcp({debug: ID, buffer: {hello: 'world'}}, 's20', 0, `https://30.paksof.com/fec/test.php?api=store`, resp=>{
    tcp({buffer: {hello: 'world'}}, 's20', 0, `https://30.paksof.com/fec/test.php?api=store`, resp=>{
      console.log(resp)
    })
    // fetch ('https://30.paksof.com/fec/test.php?api=store&vendor=kaka&lang=en', {
    //   method: 'post',
    //   body: JSON.stringify({vendor: 'find'})
    // })
    // .then (response => response.json())
    // .then (resp => {console.log(resp);debugger})
  }
  onClick101 = e => {
    e.stopPropagation()
    console.log('MasterView.onClick101.IO', IO)
  }
  onClick102 = e => {
    e.stopPropagation()
    console.log('MasterView.onClick102.park this.props.p', this.props.p)
  }
  onClick103 = e => {
    e.stopPropagation()
    console.log('MasterView.onClick103.this.state', this.state)
    // Store.set('MasterView', 'table', {id: 1, 'something': 2})
    // console.log('MasterView.onClick2 Store.i', this.state)
  }
  onClick104 = e => {
    e.stopPropagation()
    console.log('MasterView.onClick104 this.props', this.props)
  }
  onClick199 = e => {
    e.stopPropagation()
    const v = 'notice'
    const db = _.QID+4
    const lang = this.props.lang
    const vcache = cache(`${lang}${db}${v}`)
    const net = {type: 'modified', buffer: {[v]: {[db]: {modified: vcache.modified}}}}
    IO.Task.push({callback: tcp, arg: [net, 's10'], delay: 15})
    console.log('MasterView.onClick6 IO.Net', {v, db, vcache, net})
  }
  onClick0 = e => {
    e.stopPropagation()
    this.login(_.QID, 'q10', this.state.cookie.p, this.state.cookie.p, 'Queue'.substring(0, _.NAME_M), 'bytetrain@yahoo.com')
  }
  onClick1 = e => {
    e.stopPropagation()
    this.login(_.QID+1, 'kaka', 's20', this.state.cookie.p, 'Tariq R. Daudpoto s/o Nabi Buksh Daudpoto s/o Wahid Buksh Daudpoto s/o Urs Mohammad Daudpoto'.substring(0, _.NAME_M), 'bytetrain@yahoo.com', '437 242 4644', 'Hyderabad', 'Illinois', 'Canada', 'shanakhti')
  }
  onClick2 = e => {
    e.stopPropagation()
    this.login(_.QID+2, 'toronto.cabab', 's20', this.state.cookie.p, 'Toronto Cabab'.substring(0, _.NAME_M), 'bytetrain@yahoo.com')
  }
  onClick3 = e => {
    e.stopPropagation()
    this.login(_.QID+3, 'halal.chicken', 's10', this.state.cookie.p, 'Halal Chicken'.substring(0, _.NAME_M), 'bytetrain@yahoo.com')
  }
  onClick4 = e => {
    e.stopPropagation()
    this.login(_.QID+4, 'mona', 's10', this.state.cookie.p, 'Aisha L. Baloch d/o Ali Mohammad Baloch s/0 Nabi Buksh Baloch'.substring(0, _.NAME_M), 'mona@yahoo.com')
  }
  onClick5 = e => {
    e.stopPropagation()
    this.login(_.QID+5, 'ab', 's20', this.state.cookie.p, 'Usman Ahmed'.substring(0, _.NAME_M), 'ab@yahoo.com')
  }
  onClick6 = e => {
    e.stopPropagation()
    this.login(_.QID+6, 'oj', 's20', this.state.cookie.p, 'Eman Qirat'.substring(0, _.NAME_M), 'oj@yahoo.com')
  }
  onClick8 = e => {
    e.stopPropagation()
    this.login(_.QID+8, 'empty.store', 's10', this.state.cookie.p, 'Empty Store'.substring(0, _.NAME_M), 'empty.store@yahoo.com')
  }
  onClick21 = e => {
    e.stopPropagation()
    this.login(_.QID+21, 'no.file', 's10', this.state.cookie.p, 'No File'.substring(0, _.NAME_M), 'no.file@yahoo.com')
  }
  onClick22 = e => {
    e.stopPropagation()
    this.login(_.QID+22, 'no.item', 's20', this.state.cookie.p, 'No Item'.substring(0, _.NAME_M), 'no.item@yahoo.com')
  }
  onClick23 = e => {
    e.stopPropagation()
    this.login(_.QID+23, 'no.file.no.item', 's20', this.state.cookie.p, 'No File No Item'.substring(0, _.NAME_M), 'no.file.no.item@yahoo.com')
  }
  onClick29 = e => {
    e.stopPropagation()
    this.login(_.QID+29, 'decoration.asif', 's20', this.state.cookie.p, 'Decoration by Asif'.substring(0, _.NAME_M), 'asif@yahoo.com')
  }
  login = (id, username, home, park, name, email, phone, city, state, country, taxcode) => {
    const policy = `path=/;SameSite=Strict${__DEV__ ? '' : `;domain=.${_.DOMAIN};secure=1`}`
    document.cookie = `login=${Math.floor(Date.now()/1000)};${policy}`
    document.cookie = `id=${id};${policy}`
    document.cookie = `username=${username};${policy}`
    document.cookie = `home=${home};${policy}`
    document.cookie = `p=${park};${policy}`
    document.cookie = `name=${name};${policy}`
    // document.cookie = `ilogin=${username};${policy};httponly=1`
    console.log('MasterView.login', {id, username, home, park, name, email, policy, cookie: document.cookie})
    dispatch({buffer: {s10: {login: {user: {default: {[id]: [id, Math.floor(Date.now()/1000), home, username, 'pass', name, phone, email, city, state, country, taxcode, '[]', 0]}}}}}})
  }
  componentWillUnmount = () => {
    // delete(_Master_[this.state._id_])
    // delete(_Master_[this.state.key])
    // delete(_Master_)
  //   window.removeEventListener("resize", this.resize)
  //   this.unlisten && this.unlisten()
  //   // document.getElementsByTagName('body')[0].removeEventListener("click", this.onClick, false);
  }
  // resize = e => {
  //   console.log('MasterView.resize', e)
  //   this.props.action.screen(window.innerWidth, window.innerHeight)
  // }
}
// MasterView.propTypes = masterPropType;
export default connect(
  masterStateToProp,
  masterDispatchToProp
)(MasterView)
// onClick4 = e => {
//   e.stopPropagation()
//   // const uris = Uris()
//   // const vendorname = uris[1]
//   // const row = cache(vendorname) || {}
//   // // const login = row ? 1 : null
//   // const pk = row.id || _.LOGIN_AI+1
//   // const login = 1
//   // // const login = user.login
//   // const id = login ? pk : -pk
//   // document.cookie = `id=${id};path=/;SameSite=Strict`
//   // const username = row.username || 'kaka' // row ? row[USERNAME] : 'kaka'
//   // const home = row.home || 30// row ? row[HOME] : 30
//   // const name = row.name || 'Tariq R. Daudpoto s/o Nabi Buksh Daudpoto s/o Wahid Buksh Daudpoto s/o Urs Mohammad Daudpoto'.substring(0, _.NAME_M)// row ? row.name : 'Tariq R. Daudpoto s/o Nabi Buksh Daudpoto s/o Wahid Buksh Daudpoto s/o Urs Mohammad Daudpoto'.substring(0, _.NAME_M)
//   // const email = row.email || 'bytetrain@yahoo.com'
//   // if (login) {
//   //   // const username = row ? row.username : 'emptystore'
//   //   // const home = row ? row.home : 20
//   //   // const name = row ? row.name : 'Empty Store'.substring(0, _.NAME_M)
//   //   document.cookie = `login=${login};path=/;SameSite=Strict`
//   //   document.cookie = `username=${username};path=/;SameSite=Strict`
//   //   document.cookie = `name=${name};path=/;SameSite=Strict`
//   //   document.cookie = `home=${home};path=/;SameSite=Strict`
//   // }
//   // console.log('MasterView.onClick4', {vendorname, pk, login, id})
//   // dispatch({buffer: {login: {user: {default: {[id]: [id, Math.floor(Date.now()/1000), home, name, email, username, '', '{}']}}}}})
//   // // this.setState({toggle: !this.state.toggle})
//   this.login(_.LOGIN_AI=1, 'kaka', 's20', 'Tariq', 'Tariq R. Daudpoto s/o Nabi Buksh Daudpoto s/o Wahid Buksh Daudpoto s/o Urs Mohammad Daudpoto'.substring(0, _.NAME_M), 'bytetrain@yahoo.com')
// }
